import { Trans } from '@lingui/react/macro';
import type { HeaderWidgetModel } from '../../../types/widget.js';
import { getHuckConfig } from '../../utils/getHuckConfig.js';

export const HeaderWidget = ({ headerType, text }: Omit<HeaderWidgetModel, 'type'>) => {
  const config = getHuckConfig();

  if (headerType === 'title') {
    return (
      <>
        <h1>{text}</h1>
        {(config.mode === 'create' || config.mode === 'republish') && (
          <span className="sr-only">
            <Trans
              id="mobility-item-insertion.form.sr-title.autosave"
              comment="Screen reader text to let users know that we autosave every change"
            >
              All changes made in the form will be auto saved
            </Trans>
          </span>
        )}
      </>
    );
  }

  if (headerType === 'sub' || !headerType) {
    return <h2 className="mt-40 mb-16">{text}</h2>;
  }

  if (headerType === 'step-title') {
    return <h1 className="t2 mb-32">{text}</h1>;
  }

  if (headerType === 'section-title') {
    return <h2 className="t3 mt-40 mb-16">{text}</h2>;
  }
};
